/// <reference types="@welldone-software/why-did-you-render" />
import React from 'react';
export const setupWdyr = async () => {
  if (import.meta.env.VITE_NODE_ENV === 'local') {
    const { default: wdyr } = await import(
      '@welldone-software/why-did-you-render'
    );
    wdyr(React, {
      trackHooks: true,
      collapseGroups: false,
      // trackAllPureComponents: true,
      logOnDifferentValues: true,
      logOwnerReasons: true,
      exclude: [/^InlineSVG/],
      trackAllPureComponents: true,
    });
    console.log('Setup done');
  } else {
    console.log('Ignoring wydr for ' + import.meta.env.VITE_NODE_ENV + ' env.');
  }
};
